import { Component, OnInit } from '@angular/core';

declare var $:any;

@Component({
  selector: 'app-tutorial',
  templateUrl: './tutorial.component.html',
  styleUrls: ['./tutorial.component.css']
})
export class TutorialComponent implements OnInit {

  public video: string = '#ESP';

  constructor() { }

  ngOnInit() {
    var video;
    switch(localStorage.getItem("lang")){
        case 'es':
            video = '#ESP';
            break;
        case 'en':
            video = '#ENG';
            break;
        case 'it':
            video = '#ITA';
            break;
        case 'pr':
            video = '#POR';
            break;
        default:
            video = '#RUS';
            break;
    }
    this.video = video;
    console.log(this.video);
    this.activate(this.video.toLowerCase());
  }

  activate(ref:string){
    this.video = ref.toUpperCase();
    console.log(this.video);

    $('.btn-language-selected div').removeClass('btn-active');
    $('.btn-language-selected div').addClass('btn-inactive');
    $(ref).addClass('btn-active');
  }

}
